import React from 'react';
import Checkbox from '../Checkbox';
import styles from './ConfirmationText.module.scss';
import { classNames } from '../../utils/helpers';
export var ConfirmationTextSize;
(function (ConfirmationTextSize) {
    ConfirmationTextSize["Small"] = "small";
    ConfirmationTextSize["Medium"] = "medium";
    ConfirmationTextSize["Large"] = "large";
})(ConfirmationTextSize || (ConfirmationTextSize = {}));
const ConfirmationText = ({ size = ConfirmationTextSize.Medium, children, ...props }) => (React.createElement("div", { className: styles.container },
    React.createElement(Checkbox, { ...props }),
    React.createElement("div", { className: styles.box },
        React.createElement("div", { className: styles.shadow }),
        React.createElement("div", { className: classNames(styles.content, styles[size]) }, children))));
export default ConfirmationText;
